<template>
  <v-dialog v-model="visible" width="500">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>

      <v-card-text>{{ description }}</v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" text @click="deleteObject(false)">Cancel</v-btn>

        <v-btn color="green darken-1" text @click="deleteObject(true)">Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteConfirmationBox",
  props: ['visible', 'title', 'description'],
  methods: {
    // emit to parent and let them know that delete was agreed (true) or disagreed (false)
    deleteObject(confirm) {
      this.$emit('deleteObject', confirm);
    }
}
};
</script>
